export default "__VITE_ASSET__0a5ab21e__"